/* eslint-disable no-param-reassign */
import axios from 'axios';
import { API_BASE_URL } from 'constants/apiConf';
import { URLS } from 'modules/session/repository';
import { ROUTE_PATH } from 'routes';
import { applyConsumerOrigin } from 'utils/consumerOrigin';
import platform from 'utils/platform';

const formatMessageError = (error) => {
  return {
    statusCode: error?.response?.status || 400,
    data: {
      status: error?.response?.data?.status || 'ERROR',
      error: error.response?.data?.error || true,
    },
    rawData: error?.response?.data || {},
  };
};

const ApiFetch = (baseURL, { skipOrigin = false } = {}) => {
  if (!baseURL) {
    // eslint-disable-next-line no-param-reassign
    baseURL = API_BASE_URL;
  }
  const instance = axios.create({
    baseURL,
    withCredentials: true,
  });

  instance.interceptors.request.use((config) => {
    // Portal (navegador): origin=2 en esta instancia, igual que antes.
    // App nativa: origin=1 solo en los endpoints del contrato.
    // CMS usa skipOrigin para no cambiar el contenido compartido.
    return applyConsumerOrigin(config, {
      isWeb: platform.isWeb,
      skipOrigin,
    });
  });

  // Más información: https://github.com/axios/axios#interceptors
  instance.interceptors.response.use(
    (res) => {
      return res.data;
    },
    (err) => {
      if (err?.response?.status === 401 && window.USER_ID) {
        return new Promise((_, reject) => {
          fetch(`${baseURL}${URLS.session}`, { method: 'GET', credentials: 'include' }).then((res) => {
            if (res?.status === 401) {
              window.location.href = `${ROUTE_PATH.SESSION_CLOSED}?noSplashScreen=1`;
            }
            reject(formatMessageError(err));
          });
        });
      }
      return Promise.reject(formatMessageError(err));
    },
  );

  return instance;
};

export default ApiFetch;
